// @generated by TypeGen from LogbookApi/Session.swift - DO NOT EDIT

import type { ILogbookSessionClient, ISessionResponse } from "../LogbookModel/Session"
import type { ISuccessResponse } from "../LogbookServer/SuccessResponse"
import { assertTarget } from "./ApiRuntime"
import type { ApiArgs, ApiClient, ApiTarget, ApiUser } from "./ApiRuntime"

export interface ISessionExchangeRequest {
  code: string;
  state: string;
}

export interface ISessionForgotPasswordRequest {
  email: string;
}

export interface ISessionHandoffRequest {
  state: string;
}

export interface ISessionLoginRequest {
  email: string;
  password: string;
  client?: ILogbookSessionClient;
}

export interface ISessionResetPasswordRequest {
  password: string;
  passwordConfirmation: string;
}

export interface ISessionHandoffResponse {
  code: string;
}

export interface SessionEndpoints {
  "DELETE /api/session": {
    params: {};
    query: {};
    request: never;
    response: ISessionResponse;
    targets: ApiTarget[];
    permission: { session: true };
  };
  "GET /api/session": {
    params: {};
    query: {};
    request: never;
    response: ISessionResponse;
    targets: ApiTarget[];
    permission: {};
  };
  "POST /api/session": {
    params: {};
    query: {};
    request: ISessionLoginRequest;
    response: ISessionResponse;
    targets: ApiTarget[];
    permission: {};
  };
  "POST /api/session/exchange": {
    params: {};
    query: {};
    request: ISessionExchangeRequest;
    response: ISessionResponse;
    targets: ApiTarget[];
    permission: {};
  };
  "POST /api/session/handoff": {
    params: {};
    query: {};
    request: ISessionHandoffRequest;
    response: ISessionHandoffResponse;
    targets: ApiTarget[];
    permission: { session: true };
  };
  "POST /api/session/reset": {
    params: {};
    query: {};
    request: ISessionForgotPasswordRequest;
    response: ISuccessResponse;
    targets: ApiTarget[];
    permission: {};
  };
  "POST /api/session/restore": {
    params: {};
    query: {};
    request: never;
    response: ISessionResponse;
    targets: ApiTarget[];
    permission: {};
  };
  "PUT /api/session/reset/:token": {
    params: { token: string };
    query: {};
    request: ISessionResetPasswordRequest;
    response: ISuccessResponse;
    targets: ApiTarget[];
    permission: {};
  };
}

export const sessionEndpoints = {
  "DELETE /api/session": { targets: ["app", "server"], permission: { session: true } },
  "GET /api/session": { targets: ["app", "server"], permission: {} },
  "POST /api/session": { targets: ["app", "server"], permission: {} },
  "POST /api/session/exchange": { targets: ["app", "server"], permission: {} },
  "POST /api/session/handoff": { targets: ["app", "server"], permission: { session: true } },
  "POST /api/session/reset": { targets: ["server"], permission: {} },
  "POST /api/session/restore": { targets: ["app"], permission: {} },
  "PUT /api/session/reset/:token": { targets: ["server"], permission: {} },
} as const;

export class Session {
  constructor(private client: ApiClient) {}

  session = {
    delete: (a: ApiArgs<SessionEndpoints, "DELETE /api/session">) => ({
      call: (): Promise<ISessionResponse> => {
        assertTarget(this.client, "DELETE /api/session", sessionEndpoints["DELETE /api/session"].targets);
        return this.client.call<ISessionResponse>("DELETE /api/session", a);
      },
      url: (): string => this.client.url("DELETE /api/session", a),
      available: (user?: ApiUser): boolean => user != null,
    }),
    get: (a: ApiArgs<SessionEndpoints, "GET /api/session">) => ({
      call: (): Promise<ISessionResponse> => {
        assertTarget(this.client, "GET /api/session", sessionEndpoints["GET /api/session"].targets);
        return this.client.call<ISessionResponse>("GET /api/session", a);
      },
      url: (): string => this.client.url("GET /api/session", a),
      available: (_user?: ApiUser): boolean => true,
    }),
    create: (a: ApiArgs<SessionEndpoints, "POST /api/session">) => ({
      call: (): Promise<ISessionResponse> => {
        assertTarget(this.client, "POST /api/session", sessionEndpoints["POST /api/session"].targets);
        return this.client.call<ISessionResponse>("POST /api/session", a);
      },
      url: (): string => this.client.url("POST /api/session", a),
      available: (_user?: ApiUser): boolean => true,
    }),
    exchange: (a: ApiArgs<SessionEndpoints, "POST /api/session/exchange">) => ({
      call: (): Promise<ISessionResponse> => {
        assertTarget(this.client, "POST /api/session/exchange", sessionEndpoints["POST /api/session/exchange"].targets);
        return this.client.call<ISessionResponse>("POST /api/session/exchange", a);
      },
      url: (): string => this.client.url("POST /api/session/exchange", a),
      available: (_user?: ApiUser): boolean => true,
    }),
    handoff: (a: ApiArgs<SessionEndpoints, "POST /api/session/handoff">) => ({
      call: (): Promise<ISessionHandoffResponse> => {
        assertTarget(this.client, "POST /api/session/handoff", sessionEndpoints["POST /api/session/handoff"].targets);
        return this.client.call<ISessionHandoffResponse>("POST /api/session/handoff", a);
      },
      url: (): string => this.client.url("POST /api/session/handoff", a),
      available: (user?: ApiUser): boolean => user != null,
    }),
    forgotPassword: (a: ApiArgs<SessionEndpoints, "POST /api/session/reset">) => ({
      call: (): Promise<ISuccessResponse> => {
        assertTarget(this.client, "POST /api/session/reset", sessionEndpoints["POST /api/session/reset"].targets);
        return this.client.call<ISuccessResponse>("POST /api/session/reset", a);
      },
      url: (): string => this.client.url("POST /api/session/reset", a),
      available: (_user?: ApiUser): boolean => true,
    }),
    restore: (a: ApiArgs<SessionEndpoints, "POST /api/session/restore">) => ({
      call: (): Promise<ISessionResponse> => {
        assertTarget(this.client, "POST /api/session/restore", sessionEndpoints["POST /api/session/restore"].targets);
        return this.client.call<ISessionResponse>("POST /api/session/restore", a);
      },
      url: (): string => this.client.url("POST /api/session/restore", a),
      available: (_user?: ApiUser): boolean => true,
    }),
    resetPassword: (a: ApiArgs<SessionEndpoints, "PUT /api/session/reset/:token">) => ({
      call: (): Promise<ISuccessResponse> => {
        assertTarget(this.client, "PUT /api/session/reset/:token", sessionEndpoints["PUT /api/session/reset/:token"].targets);
        return this.client.call<ISuccessResponse>("PUT /api/session/reset/:token", a);
      },
      url: (): string => this.client.url("PUT /api/session/reset/:token", a),
      available: (_user?: ApiUser): boolean => true,
    }),
  };
}
